import { render, staticRenderFns } from "./RetailOtherUniqueSingleTenant.vue?vue&type=template&id=db280872&scoped=true&"
import script from "./RetailOtherUniqueSingleTenant.vue?vue&type=script&lang=ts&"
export * from "./RetailOtherUniqueSingleTenant.vue?vue&type=script&lang=ts&"
import style0 from "./RetailOtherUniqueSingleTenant.vue?vue&type=style&index=0&id=db280872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db280872",
  null
  
)

export default component.exports